import "./LeaveAReview.module.css";
import Header from "@/reusable_sections/Header";
import LeaveAReview from "./sections/LeaveAReview";
import ThankYou from "./sections/ThankYou";
import ShareYourReview from "./sections/ShareYourReview";
import Footer from "@/reusable_sections/Footer";
export default function LeaveAReviewPage() {
  return <div>
      <Header />
      <LeaveAReview />
      <ThankYou />
      <ShareYourReview />
      <Footer />
    </div>;
}